<template>
    <div class="col-lg-6 col-md-12 bg-img none-992">
        <div class="info">
          <div class="logo clearfix">
            <a href="/">
              <img src="/assets/img/logos/logo.png" alt="logo">
            </a>
          </div>
          <div class="btn-section clearfix">
            <a href="/" class="link-btn btn-1">Login</a>
            <div class="clearfix"></div>
            <a href="dang-ky" class="link-btn btn-1 active default-bg">Register</a>
          </div>
          <ul class="social-list">
            <li>
              <a href="#" class="facebook-bg">
                <i class="fa fa-facebook"></i>
              </a>
            </li>
            <li>
              <a href="#" class="twitter-bg">
                <i class="fa fa-twitter"></i>
              </a>
            </li>
            <li>
              <a href="#" class="google-bg">
                <i class="fa fa-google"></i>
              </a>
            </li>
            <li>
              <a href="#" class="linkedin-bg">
                <i class="fa fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a href="#" class="pinterest-bg">
                <i class="fa fa-pinterest"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
</template>

<script>
    export default {
        methods: {
            logout() {
                if (confirm('Bạn chắc chắn muốn thoát ?')) {
                    this.$router.push({
                        name: 'Logout'
                    })
                }
            }
        }
    }
</script>
<style scoped>
    #mcontentLmenubar {
        list-style: none;
        font-size: 16px;
        line-height: 28px;
        text-align: left;
    }
    .menu-active {
        color: rgb(255, 128, 1) !important;
    }
</style>